module.exports = __webpack_public_path__ + "static/img/img21.4c167f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img21.png
// module id = zjXF
// module chunks = 18